export enum DurationFilter {
    LatestNinetyDays = 'latest-ninety-days',
    LatestThirtyDays = 'latest-thirty-days',
    LatestMonth = 'latest-month',
    LatestQuarter = 'latest-quarter',
    LatestSemester = 'latest-semester',
    LatestYear = 'latest-year',
    AllTime = 'all-time',
}
